import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../../../images/svg-decorator-blob-2.svg";

export const SvgDotPattern2 = tw(
  SvgDotPatternIcon,
)`tw-absolute tw-bottom-0 tw-left-0 tw-transform tw-translate-y-2/3 -tw-translate-x-1/2 -tw-z-10 tw-opacity-50 tw-text-primary-500 tw-fill-current tw-w-32`;
